import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { INDUSTRIES, HEADER_IMG } from "../data/site";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <PageHeader
        overline="Industries Served"
        title="Sectors we serve."
        subtitle="Deep manufacturing expertise across 18 industries — from automotive and EV to aerospace, defence, railways and renewable energy."
        bgImage={HEADER_IMG.industries}
      />

      <section className="max-w-[1440px] mx-auto px-5 sm:px-8 py-20 md:py-28">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-border border border-border">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.title} delay={(i % 4) * 0.05}
              className="bg-card p-8 md:p-10 flex flex-col items-start gap-5 group hover:bg-navy transition-colors">
              <span className="h-14 w-14 border border-border group-hover:border-white/20 grid place-items-center transition-colors">
                <ind.icon size={26} className="text-brand-orange" strokeWidth={1.5} />
              </span>
              <h3 className="font-display font-bold text-xl group-hover:text-white transition-colors">{ind.title}</h3>
              <Link to="/quote" className="mt-auto inline-flex items-center gap-2 font-mono uppercase text-[10px] tracking-[0.2em] text-brand-orange opacity-0 group-hover:opacity-100 transition-opacity">
                Source This <ArrowUpRight size={13} />
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-brand-orange text-white py-20 md:py-28">
        <div className="max-w-[1440px] mx-auto px-5 sm:px-8 text-center">
          <Reveal><h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter mb-8">Source for your industry today.</h2></Reveal>
          <Reveal delay={0.1}>
            <Link to="/quote" className="inline-flex items-center gap-2 bg-navy px-8 py-4 font-mono uppercase text-[11px] tracking-[0.18em] hover:bg-navy-soft transition-colors">
              Request a Quote <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
